/** Centralized React Query keys for the Vendor portal. */
export const queryKeys = {
  auth: {
    me: ["auth", "me"] as const,
    contexts: ["auth", "contexts"] as const,
  },
  onboarding: {
    all: ["onboarding"] as const,
    overview: ["onboarding", "overview"] as const,
    profile: ["onboarding", "profile"] as const,
    status: ["onboarding", "status"] as const,
  },
  approvals: {
    all: ["approvals"] as const,
    list: (params?: Record<string, unknown>) => ["approvals", "list", params ?? {}] as const,
    detail: (approvalId: string) => ["approvals", "detail", approvalId] as const,
  },
  services: {
    all: ["services"] as const,
    list: (params?: Record<string, unknown>) => ["services", "list", params ?? {}] as const,
    available: (params?: Record<string, unknown>) =>
      ["services", "available", params ?? {}] as const,
    detail: (vendorServiceId: string) => ["services", "detail", vendorServiceId] as const,
    readiness: (vendorServiceId: string) => ["services", "readiness", vendorServiceId] as const,
    coverage: (vendorServiceId: string) => ["services", "coverage", vendorServiceId] as const,
    effectiveCoverage: (vendorServiceId: string) =>
      ["services", "effective-coverage", vendorServiceId] as const,
  },
  coverage: {
    all: ["coverage"] as const,
    organization: ["coverage", "organization"] as const,
    overview: ["coverage", "overview"] as const,
  },
  assets: {
    all: ["assets"] as const,
    trucks: ["assets", "trucks"] as const,
    containers: ["assets", "containers"] as const,
    drivers: ["assets", "drivers"] as const,
  },
  orders: {
    all: ["orders"] as const,
    list: (params?: Record<string, unknown>) => ["orders", "list", params ?? {}] as const,
    detail: (orderId: string) => ["orders", "detail", orderId] as const,
    rejectionReasons: ["orders", "rejection-reasons"] as const,
  },
  workOrders: {
    all: ["work-orders"] as const,
    list: (params?: Record<string, unknown>) => ["work-orders", "list", params ?? {}] as const,
    detail: (workOrderId: string) => ["work-orders", "detail", workOrderId] as const,
  },
  deliveryTimeSlots: {
    public: ["delivery-time-slots", "public"] as const,
  },
  biddingRoom: {
    all: ["bidding-room"] as const,
    list: (params?: Record<string, unknown>) => ["bidding-room", "list", params ?? {}] as const,
    detail: (requestId: string) => ["bidding-room", "detail", requestId] as const,
  },
  bids: {
    all: ["bids"] as const,
    list: (params?: Record<string, unknown>) => ["bids", "list", params ?? {}] as const,
  },
  pricing: {
    all: ["pricing"] as const,
    versions: (vendorServiceId: string) => ["pricing", "versions", vendorServiceId] as const,
  },
  catalog: {
    all: ["catalog"] as const,
    services: (params?: Record<string, unknown>) => ["catalog", "services", params ?? {}] as const,
    service: (serviceId: string) => ["catalog", "services", serviceId] as const,
    serviceOptions: (params?: Record<string, unknown>) =>
      ["catalog", "service-options", params ?? {}] as const,
    serviceOption: (optionId: string) => ["catalog", "service-options", optionId] as const,
  },
  geography: {
    all: ["geography"] as const,
    countries: (params?: Record<string, unknown>) =>
      ["geography", "countries", params ?? {}] as const,
    country: (countryId: string) => ["geography", "countries", countryId] as const,
    municipalities: (params?: Record<string, unknown>) =>
      ["geography", "municipalities", params ?? {}] as const,
    municipality: (municipalityId: string) =>
      ["geography", "municipalities", municipalityId] as const,
    districts: (params?: Record<string, unknown>) =>
      ["geography", "districts", params ?? {}] as const,
    district: (districtId: string) => ["geography", "districts", districtId] as const,
    /** Every page, archived included — id → name lookups for historical records. */
    municipalityDirectory: ["geography", "municipalities", "directory"] as const,
    districtDirectory: ["geography", "districts", "directory"] as const,
  },
  notifications: {
    all: ["notifications"] as const,
    list: (params?: Record<string, unknown>) => ["notifications", "list", params ?? {}] as const,
  },
  documents: {
    all: ["documents"] as const,
    list: ["documents", "list"] as const,
  },
} as const;
